import React from 'react';
import PropTypes from 'prop-types';

import { formatFieldValue } from 'form/helpers/field_value_formatter';

import RealizeInputAutocomplete from 'realize/components/input/input_autocomplete';

import InputAutocompleteSelect from './input_autocomplete_select';

import OptionsPropsHelper from '../../../helpers/options_props_helper';

export default class InputAutocomplete extends React.Component {
	static propTypes = {
		options: PropTypes.array,
		optionsUrl: PropTypes.string,
		optionsUrlParams: PropTypes.array,
		clientSideSearch: PropTypes.bool
	};

	static defaultProps = {
		options: [],
		optionsUrl: null,
		optionsUrlParams: [],
		clientSideSearch: true
	};

	buildOptionsWithValue() {
		const values = Array.isArray(this.props.value) ? this.props.value : [this.props.value];
		const options = this.props.options || [];

		const existingOptions = options
			.map((option) => ({
				name: formatFieldValue(option.name.trim()) + "",
				value: this.trimStr(option.value)
			}));

		const newOptions = values
			.filter(value => (
				value !== undefined && value !== null && value !== '' && !options.map(option => this.trimStr(option.name)).includes(this.trimStr(value.toString())) && !options.map(option => this.trimStr(option.value)).includes(this.trimStr(value.toString()))
			))
			.map(value => ({ name: formatFieldValue(this.trimStr(value.toString())), value: this.trimStr(value) }));

		return existingOptions.concat(newOptions);
	}

	trimStr(value) {
		return (typeof value === 'string') ? value.toString().trim() : value.toString();
	}

	serialize() {
		var inputRef = this.refs.input;
		var serialize = inputRef.serialize();
		for (let inputSerialize in serialize) {
			if (Array.isArray(serialize[inputSerialize]) && !serialize[inputSerialize].length) {
				serialize[inputSerialize] = null;
			}
		}
		return serialize;
	}

	render() {
		return (
			<RealizeInputAutocomplete
				{...this.props}
				value={this.props.value}
				optionsUrl={OptionsPropsHelper.buildOptionsUrl(this.props.optionsUrl, this.props.optionsUrlParams)}
				options={this.buildOptionsWithValue()}
				inputAutoCompleteSelectComponent={InputAutocompleteSelect}
				ref="input" />
		);
	}
}
